/**
 * ErrorBoundary Component
 * Catches React component errors and displays a fallback UI
 */

import React from 'react';
import { Container, Alert, Button } from 'react-bootstrap';
import { logService } from '../../services/logService';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      error: null,
      errorInfo: null,
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log the error to our logging service
    logService.logError(
      `React Component Error: ${error.message}`,
      error,
      {
        componentStack: errorInfo.componentStack,
        errorBoundary: true,
      }
    );

    // Save error details to state for display
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
  }

  handleReset = () => {
    this.setState({
      hasError: false,
      error: null,
      errorInfo: null,
    });
    // Ricarica la pagina
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      // Fallback UI
      return (
        <Container className="mt-5">
          <Alert variant="danger">
            <Alert.Heading>
              <i className="fas fa-exclamation-triangle me-2"></i>
              Si è verificato un errore
            </Alert.Heading>
            <p>
              Ci scusiamo per l'inconveniente. Si è verificato un errore imprevisto
              nell'applicazione. Il problema è stato registrato e verrà analizzato.
            </p>
            <hr />
            <div className="d-flex justify-content-between align-items-center">
              <Button variant="outline-danger" onClick={this.handleReset}>
                <i className="fas fa-redo me-2"></i>
                Ricarica la pagina
              </Button>
              {process.env.NODE_ENV === 'development' && this.state.error && (
                <div className="text-start mt-3">
                  <details style={{ whiteSpace: 'pre-wrap', fontSize: '0.85rem' }}>
                    <summary style={{ cursor: 'pointer', fontWeight: 'bold' }}>
                      Dettagli errore (solo in development)
                    </summary>
                    <div className="mt-2">
                      <strong>Error:</strong> {this.state.error.toString()}
                      <br />
                      <strong>Stack:</strong>
                      <pre style={{ fontSize: '0.75rem', backgroundColor: '#f8f9fa', padding: '10px' }}>
                        {this.state.errorInfo?.componentStack}
                      </pre>
                    </div>
                  </details>
                </div>
              )}
            </div>
          </Alert>
        </Container>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
